export default "__VITE_ASSET__DHGhh_Nd__"